import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { LangContext } from '../App';

const T = {
  fr: {
    title: 'Politique de confidentialité',
    majAu: 'En vigueur depuis le',
    majDate: '7 mai 2025',
    conformite:
      'Conforme à la Loi modernisant des dispositions législatives en matière de protection des renseignements personnels (Loi 25, Québec)',
    noteLangue:
      'La version française constitue la version officielle de ce document, conformément à la Charte de la language française (Québec). La version anglaise est fournie à title informatif uniquement.',

    s1titre: '1. Données collectées',
    s1contenu: [
      "Informations d'identité : name complet, address courriel, numéro de téléphone (optionnel).",
      'Localisation : code postal, utilisé exclusivement pour les recherches de proximité entre chasseurs et propriétaires fonciers.',
      "Informations de rôle : type d'utilisateur (chasseur, agriculteur, propriétaire, guide, trappeur, vendeur d'équipement), numéros de permis provinciaux selon le rôle.",
      'Données de publication : descriptions de terres, disponibilités, informations sur les réservations.',
      "Données techniques : journaux d'accès, adresses IP (conservation : 90 jours), pour la sécurité et la détection des abus.",
      'Authentification : hachage sécurisé du mot de passe (bcrypt), clé secrète 2FA si activée.',
    ],

    s2titre: '2. Finalités du traitement',
    s2contenu: [
      'Mise en relation entre chasseurs et propriétaires fonciers, agriculteurs ou guides de chasse — finalité principale de la plateforme.',
      "Gestion du compte utilisateur : authentification, vérification de l'address courriel, récupération du compte.",
      'Communications transactionnelles liées aux réservations, locations ou transactions sur la plateforme.',
      'Respect des obligations légales, prévention de la fraude et maintien de la sécurité de la plateforme.',
      'Amélioration des services (statistiques agrégées et anonymisées uniquement).',
    ],
    s2note:
      "Aucune information personnelle n'est vendue, louée ou partagée avec des tiers à des fins publicitaires.",

    s3titre: '3. Durée de conservation',
    s3lignes: [
      { periode: 'Compte active', duree: 'Durée de vie du compte' },
      {
        periode: 'Après suppression du compte',
        duree: '2 ans (obligations légales et litiges potentiels)',
      },
      { periode: 'Journaux techniques (IP, accès)', duree: '90 jours' },
      { periode: 'Données de transactions', duree: '7 ans (obligations fiscales)' },
    ],

    s4titre: "4. Droits de l'utilisateur",
    s4intro: 'Conformément à la Loi 25, vous disposez des droits suivants :',
    s4droits: [
      {
        droit: "Droit d'accès",
        desc: 'Obtenir une copie de vos renseignements personnels détenus par ChasseHunt.',
      },
      {
        droit: 'Droit de rectification',
        desc: 'Corriger ou mettre à jour vos informations inexactes ou incomplètes.',
      },
      {
        droit: 'Droit à la suppression',
        desc: "Demander l'effacement de vos renseignements personnels, sous réserve des obligations légales de conservation.",
      },
      {
        droit: 'Droit à la portabilité',
        desc: 'Recevoir vos données dans un format structuré et couramment utilisé.',
      },
      {
        droit: 'Retrait du consentement',
        desc: 'Retirer votre consentement au traitement à tout moment, sans effet rétroactif.',
      },
      {
        droit: 'Droit de plainte',
        desc: "Déposer une plainte auprès de la Commission d'accès à l'information du Québec (CAI) si vous estimez que vos droits ne sont pas respectés.",
      },
    ],
    s4exercer: 'Pour exercer vos droits, contactez-nous à ',

    s5titre: '5. Sécurité des données',
    s5contenu:
      'ChasseHunt met en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos renseignements personnels contre tout accès non autorisé, modification, divulgation ou destruction. Les mots de passe sont hachés avec bcrypt (facteur de coût 12). Les connexions sont chiffrées via HTTPS/TLS.',

    s6titre: '6. Témoins de connexion (cookies)',
    s6contenu:
      "La plateforme utilise uniquement des jetons d'authentification JWT stockés localement dans votre navigateur (localStorage). Aucun témoin publicitaire ou de traçage n'est utilisé.",

    s7titre: '7. Transferts hors Québec',
    s7contenu:
      'Vos données sont hébergées sur des serveurs situés au Canada (Render, région Canada). Tout transfert éventuel hors du Québec est encadré par des protections équivalentes à celles prévues par la Loi 25.',

    s8titre: '8. Modifications de la politique',
    s8contenu:
      'Toute modification substantielle de cette politique vous sera notifiée par courriel ou lors de votre prochaine connexion. La version en vigueur est toujours consultable à cette address.',

    s9titre: '9. Responsable de la protection des renseignements personnels',
    s9nom: 'Pierre-André Turcotte',
    s9role: 'Fondateur, ChasseHunt',
    s9contact: 'admin@chassehunt.ca',
    s9cai: "Commission d'accès à l'information du Québec",
    s9caiUrl: 'https://www.cai.gouv.qc.ca',

    retour: "← Retour à l'accueil",
  },
  en: {
    title: 'Privacy Policy',
    majAu: 'In effect since',
    majDate: 'May 7, 2025',
    conformite:
      "Compliant with Quebec's Act to modernize legislative provisions as regards the protection of personal information (Law 25)",
    noteLangue:
      'The French version of this document is the official version pursuant to the Charter of the French Language (Quebec). The English version is provided for information purposes only.',

    s1titre: '1. Data Collected',
    s1contenu: [
      'Identity information: full name, email address, phone number (optional).',
      'Location: postal code, used exclusively for proximity searches between hunters and landowners.',
      'Role information: user type (hunter, farmer, landowner, guide, trapper, equipment dealer), provincial licence numbers as applicable.',
      'Listing data: land descriptions, availability, booking information.',
      'Technical data: access logs, IP addresses (retention: 90 days), for security and abuse detection.',
      'Authentication: securely hashed password (bcrypt), 2FA secret key if enabled.',
    ],

    s2titre: '2. Purposes of Processing',
    s2contenu: [
      "Connecting hunters with landowners, farmers, and hunting guides — the platform's primary purpose.",
      'User account management: authentication, email verification, account recovery.',
      'Transactional communications related to bookings, rentals, or platform transactions.',
      'Compliance with legal obligations, fraud prevention, and platform security.',
      'Service improvement (aggregated and anonymised statistics only).',
    ],
    s2note:
      'No personal information is sold, rented, or shared with third parties for advertising purposes.',

    s3titre: '3. Data Retention',
    s3lignes: [
      { periode: 'Active account', duree: 'Duration of account' },
      {
        periode: 'After account deletion',
        duree: '2 years (legal obligations and potential disputes)',
      },
      { periode: 'Technical logs (IP, access)', duree: '90 days' },
      { periode: 'Transaction data', duree: '7 years (tax obligations)' },
    ],

    s4titre: '4. User Rights',
    s4intro: 'Under Law 25, you have the following rights:',
    s4droits: [
      {
        droit: 'Right of access',
        desc: 'Obtain a copy of the personal information ChasseHunt holds about you.',
      },
      {
        droit: 'Right of rectification',
        desc: 'Correct or update inaccurate or incomplete information.',
      },
      {
        droit: 'Right to erasure',
        desc: 'Request deletion of your personal information, subject to legal retention requirements.',
      },
      {
        droit: 'Right to portability',
        desc: 'Receive your data in a structured, commonly used format.',
      },
      {
        droit: 'Withdrawal of consent',
        desc: 'Withdraw your consent to processing at any time, without retroactive effect.',
      },
      {
        droit: 'Right to complain',
        desc: "File a complaint with the Commission d'accès à l'information du Québec (CAI) if you believe your rights are not respected.",
      },
    ],
    s4exercer: 'To exercise your rights, contact us at ',

    s5titre: '5. Data Security',
    s5contenu:
      'ChasseHunt implements appropriate technical and organisational measures to protect your personal information against unauthorised access, modification, disclosure, or destruction. Passwords are hashed with bcrypt (cost factor 12). Connections are encrypted via HTTPS/TLS.',

    s6titre: '6. Cookies',
    s6contenu:
      'The platform uses only JWT authentication tokens stored locally in your browser (localStorage). No advertising or tracking cookies are used.',

    s7titre: '7. Cross-Border Transfers',
    s7contenu:
      'Your data is hosted on servers located in Canada (Render, Canada region). Any potential transfer outside Quebec is governed by protections equivalent to those required by Law 25.',

    s8titre: '8. Policy Updates',
    s8contenu:
      'Any material changes to this policy will be communicated by email or at your next login. The current version is always available at this address.',

    s9titre: '9. Privacy Officer',
    s9nom: 'Pierre-André Turcotte',
    s9role: 'Founder, ChasseHunt',
    s9contact: 'admin@chassehunt.ca',
    s9cai: "Commission d'accès à l'information du Québec",
    s9caiUrl: 'https://www.cai.gouv.qc.ca',

    retour: '← Back to home',
  },
};

export default function PolitiqueConfidentialite() {
  const { lang } = useContext(LangContext);
  const t = T[lang];

  const s = {
    page: {
      minHeight: '100vh',
      background: 'var(--couleur-fond)',
      color: 'var(--couleur-texte)',
    },
    main: {
      maxWidth: '820px',
      margin: '0 auto',
      padding: '2.5rem 1.5rem 5rem',
    },
    h1: {
      fontFamily: 'Georgia, serif',
      fontSize: '1.85rem',
      fontWeight: 700,
      color: 'var(--couleur-or)',
      marginBottom: '0.4rem',
    },
    sousTitre: {
      fontSize: '0.82rem',
      color: 'rgba(232,224,208,0.45)',
      marginBottom: '0.3rem',
    },
    conformite: {
      display: 'inline-block',
      background: 'rgba(184,134,11,0.1)',
      border: '1px solid rgba(184,134,11,0.25)',
      borderRadius: '6px',
      color: 'rgba(232,224,208,0.65)',
      fontSize: '0.77rem',
      padding: '0.35rem 0.8rem',
      marginBottom: '2.5rem',
      lineHeight: 1.5,
    },
    section: {
      background: 'var(--couleur-fond-carte)',
      border: '1px solid var(--couleur-bordure-forte)',
      borderRadius: '10px',
      padding: '1.5rem 1.8rem',
      marginBottom: '1.2rem',
    },
    h2: {
      fontFamily: 'Georgia, serif',
      fontSize: '1rem',
      fontWeight: 700,
      color: 'var(--couleur-or)',
      marginBottom: '0.9rem',
    },
    p: {
      fontSize: '0.9rem',
      color: 'rgba(232,224,208,0.78)',
      lineHeight: 1.7,
      margin: 0,
    },
    li: {
      fontSize: '0.9rem',
      color: 'rgba(232,224,208,0.78)',
      lineHeight: 1.7,
      marginBottom: '0.3rem',
    },
    tableau: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.87rem',
      marginTop: '0.3rem',
    },
    th: {
      textAlign: 'left',
      padding: '0.5rem 0.8rem',
      background: 'rgba(28,58,28,0.5)',
      color: 'rgba(232,224,208,0.65)',
      fontWeight: 600,
      fontSize: '0.78rem',
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      borderBottom: '1px solid var(--couleur-bordure-forte)',
    },
    td: {
      padding: '0.5rem 0.8rem',
      borderBottom: '1px solid rgba(28,58,28,0.5)',
      color: 'rgba(232,224,208,0.78)',
      verticalAlign: 'top',
    },
    droitBadge: {
      display: 'inline-block',
      background: 'rgba(184,134,11,0.12)',
      border: '1px solid rgba(184,134,11,0.25)',
      borderRadius: '4px',
      color: 'var(--couleur-or)',
      fontSize: '0.78rem',
      fontWeight: 600,
      padding: '0.1rem 0.5rem',
      marginBottom: '0.2rem',
    },
    rating: {
      background: 'rgba(28,58,28,0.4)',
      border: '1px solid rgba(28,58,28,0.8)',
      borderRadius: '6px',
      padding: '0.7rem 1rem',
      fontSize: '0.84rem',
      color: 'rgba(232,224,208,0.65)',
      marginTop: '0.8rem',
      lineHeight: 1.6,
    },
    contactCard: {
      background: 'rgba(28,58,28,0.35)',
      border: '1px solid var(--couleur-bordure-forte)',
      borderRadius: '8px',
      padding: '1rem 1.2rem',
      marginTop: '0.5rem',
    },
    lien: {
      color: 'var(--couleur-or)',
      textDecoration: 'none',
    },
    retour: {
      display: 'inline-block',
      marginBottom: '1.5rem',
      color: 'rgba(232,224,208,0.45)',
      fontSize: '0.85rem',
      textDecoration: 'none',
      transition: 'color 0.15s',
    },
  };

  return (
    <div style={s.page}>
      <Header />
      <main style={s.main}>
        <Link
          to="/"
          style={s.retour}
          onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--couleur-or)')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(232,224,208,0.45)')}
        >
          {t.retour}
        </Link>

        <h1 style={s.h1}>{t.title}</h1>
        <p style={s.sousTitre}>
          {t.majAu} {t.majDate}
        </p>
        <span style={s.conformite}>{t.conformite}</span>

        {/* Note language officielle */}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.6rem',
            background: lang === 'en' ? 'rgba(100,80,20,0.15)' : 'rgba(28,58,28,0.3)',
            border: `1px solid ${lang === 'en' ? 'rgba(201,162,39,0.2)' : 'rgba(28,58,28,0.7)'}`,
            borderRadius: '8px',
            padding: '0.75rem 1rem',
            marginBottom: '2rem',
            fontSize: '0.81rem',
            color: 'rgba(232,224,208,0.55)',
            lineHeight: 1.55,
          }}
        >
          <span style={{ fontSize: '1rem', flexShrink: 0 }}>🏛️</span>
          <span>{t.noteLangue}</span>
        </div>

        {/* Section 1 — Données collectées */}
        <div style={s.section}>
          <h2 style={s.h2}>{t.s1titre}</h2>
          <ul style={{ margin: 0, paddingLeft: '1.3rem' }}>
            {t.s1contenu.map((item, i) => (
              <li key={i} style={s.li}>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Section 2 — Finalités */}
        <div style={s.section}>
          <h2 style={s.h2}>{t.s2titre}</h2>
          <ul style={{ margin: 0, paddingLeft: '1.3rem' }}>
            {t.s2contenu.map((item, i) => (
              <li key={i} style={s.li}>
                {item}
              </li>
            ))}
          </ul>
          <div style={s.rating}>{t.s2note}</div>
        </div>

        {/* Section 3 — Conservation */}
        <div style={s.section}>
          <h2 style={s.h2}>{t.s3titre}</h2>
          <table style={s.tableau}>
            <thead>
              <tr>
                <th style={s.th}>{lang === 'fr' ? 'Catégorie' : 'Category'}</th>
                <th style={s.th}>{lang === 'fr' ? 'Durée' : 'Duration'}</th>
              </tr>
            </thead>
            <tbody>
              {t.s3lignes.map((ligne, i) => (
                <tr key={i}>
                  <td style={s.td}>{ligne.periode}</td>
                  <td style={s.td}>{ligne.duree}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Section 4 — Droits */}
        <div style={s.section}>
          <h2 style={s.h2}>{t.s4titre}</h2>
          <p style={{ ...s.p, marginBottom: '0.9rem' }}>{t.s4intro}</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            {t.s4droits.map((d, i) => (
              <div key={i} style={{ display: 'flex', gap: '0.8rem', alignItems: 'flex-start' }}>
                <span style={s.droitBadge}>{d.droit}</span>
                <span style={{ ...s.p, flex: 1 }}>{d.desc}</span>
              </div>
            ))}
          </div>
          <p style={{ ...s.p, marginTop: '1rem' }}>
            {t.s4exercer}
            <a href="mailto:admin@chassehunt.ca" style={s.lien}>
              admin@chassehunt.ca
            </a>
            .
          </p>
        </div>

        {/* Section 5 — Sécurité */}
        <div style={s.section}>
          <h2 style={s.h2}>{t.s5titre}</h2>
          <p style={s.p}>{t.s5contenu}</p>
        </div>

        {/* Section 6 — Cookies */}
        <div style={s.section}>
          <h2 style={s.h2}>{t.s6titre}</h2>
          <p style={s.p}>{t.s6contenu}</p>
        </div>

        {/* Section 7 — Transferts */}
        <div style={s.section}>
          <h2 style={s.h2}>{t.s7titre}</h2>
          <p style={s.p}>{t.s7contenu}</p>
        </div>

        {/* Section 8 — Modifications */}
        <div style={s.section}>
          <h2 style={s.h2}>{t.s8titre}</h2>
          <p style={s.p}>{t.s8contenu}</p>
        </div>

        {/* Section 9 — Responsable */}
        <div style={s.section}>
          <h2 style={s.h2}>{t.s9titre}</h2>
          <div style={s.contactCard}>
            <div
              style={{
                fontWeight: 700,
                color: 'var(--couleur-texte)',
                fontSize: '0.95rem',
                marginBottom: '0.2rem',
              }}
            >
              {t.s9nom}
            </div>
            <div
              style={{
                color: 'rgba(232,224,208,0.55)',
                fontSize: '0.85rem',
                marginBottom: '0.5rem',
              }}
            >
              {t.s9role}
            </div>
            <a href="mailto:admin@chassehunt.ca" style={{ ...s.lien, fontSize: '0.9rem' }}>
              admin@chassehunt.ca
            </a>
          </div>
          <p
            style={{
              ...s.p,
              marginTop: '1rem',
              fontSize: '0.84rem',
              color: 'rgba(232,224,208,0.5)',
            }}
          >
            {lang === 'fr'
              ? 'Vous pouvez également déposer une plainte auprès de la '
              : 'You may also file a complaint with the '}
            <a href={t.s9caiUrl} target="_blank" rel="noopener noreferrer" style={s.lien}>
              {t.s9cai}
            </a>
            .
          </p>
        </div>
      </main>
    </div>
  );
}
